import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "v-switch__el" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "v-switch__marker" })
], -1)

import { computed } from '@vue/reactivity';


export default /*#__PURE__*/_defineComponent({
  __name: 'VSwitch',
  props: {
    value: null,
    modelValue: { type: [Boolean, Array] },
    label: null,
    modelParentValue: { type: Boolean, default: true },
    modelBusinessValue: { type: Boolean, default: true },
    modelUnpaidValue: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { value?: string | number, modelValue?: boolean | (string | number)[], label?: string, modelParentValue: boolean, modelBusinessValue: boolean, modelUnpaidValue: boolean }




const checked = computed(() => {
  if (Array.isArray(props.modelValue)) {
    if (!props.value) return false
    return props.modelValue.includes(props.value)
  } else {
    return props.modelValue || false
  }
})

const onClick = (e: MouseEvent) => {
  if (Array.isArray(props.modelValue)) {
    if (!checked.value) {
      props.modelValue.push(props.value!)
    } else {
      props.modelValue.splice(props.modelValue.indexOf(props.value!), 1)
    }
    emit("update:modelValue", props.modelValue, e)
  } else {
    emit("update:modelValue", !props.modelValue, e)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-switch", { checked: _unref(checked), 'parent-checked': _unref(checked) && !props.modelParentValue, 'business-checked': _unref(checked) && !props.modelBusinessValue, 'unpaid-checked': _unref(checked) && props.modelUnpaidValue}]),
    onClick: onClick
  }, [
    _hoisted_1,
    _createTextVNode(" " + _toDisplayString(props.label), 1)
  ], 2))
}
}

})